<template>
  <section id="vendors-allocated-order">
    <div class="container bg-light-grey mb-16">
      <div class="table-header px-4">
        <div class="nav">
          <button onclick="window.history.back();" class="flex items-center">
            <svg viewBox="0 0 448 512" class="w-5"><path fill="white" d="M231.536 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113L238.607 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg>
          </button>
        </div>

        <h3 class="mb-2">Allocated Order #{{ order.aoId }}</h3>
      </div>

      <div class="content py-4">
        <section id="info" class="shadow-sm p-4">
          <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
              <div class="px-4 sm:px-0">
                <h2 class="header text-xl text-green">Order Information</h2>
              </div>
            </div>

            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="shadow sm:rounded-md">
                <div class="px-4 py-5 bg-white sm:p-6 flex flex-col">

                  <h2 class="text-base text-black px-4">Order ID: <span class="text-green normal-case" v-html="order.reference"/></h2>

                  <div class="status flex">
                    <h2 class="text-base text-black px-4 whitespace-no-wrap">Order status:</h2>

                    <select
                      name="status"
                      id="status"
                      class="h-10 w-1/3 form-select block pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                      v-model="orderStatus"
                      :disabled=isDisabled
                    >
                      <option
                        v-for="status in statuses"
                        :key="status.id"
                        :value="status.value"
                      >
                        {{ status.text }}
                      </option>
                    </select>
                  </div>

                  <div class="status flex py-2">
                    <h2 class="text-base text-black px-4 whitespace-no-wrap">Allocation order status:</h2>

                    <select
                      name="allocated-status"
                      id="allocated-status"
                      class="h-10 w-1/3 form-select block pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                      v-model="allocationOrderStatus"
                      :disabled=isDisabled
                    >
                      <option
                        v-for="status in statuses"
                        :key="status.id"
                        :value="status.value"
                      >
                        {{ status.text }}
                      </option>
                    </select>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

        <form method="post" accept-charset="UTF-8" action="">
          <input type="hidden" name="CRAFT_CSRF_TOKEN" :value="order.token">

          <section id="buyer" class="shadow-sm p-4">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h2 class="header text-xl text-green">Buyer's Information</h2>
                </div>
              </div>

              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6 flex flex-wrap">
                    <div class="w-full p-2">
                      <label for="accountName" class="block text-sm font-medium leading-5 text-gray-700">Company Name</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="accountName"
                          :value="order.billing.title"
                          required
                          disabled
                        >
                      </div>
                    </div>

                    <div class="w-5/12 p-2">
                      <label for="regionalDirector" class="block text-sm font-medium leading-5 text-gray-700">Regional Director</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <p
                          class="form-input block w-full sm:text-sm sm:leading-5 disabled"
                          v-html="regionalDirector"
                        />
                      </div>
                    </div>

                    <div class="w-3/12 p-2">
                      <label for="createdOn" class="block text-sm font-medium leading-5 text-gray-700">Created On</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="createdOn"
                          :value="order.orderDate"
                          disabled
                        >
                      </div>
                    </div>

                    <div class="w-3/12 p-2">
                      <label for="lastUpdated" class="block text-sm font-medium leading-5 text-gray-700">Last Updated On</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="lastUpdated"
                          :value="order.orderDate"
                          disabled
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="shipping" class="shadow-sm p-4">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h2 class="header text-xl text-green">Shipping Information</h2>
                </div>
              </div>

              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6 flex flex-wrap">
                    <div class="w-full p-2">
                      <label for="shipToName" class="block text-sm font-medium leading-5 text-gray-700">Ship To Name</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="shipToAddress"
                          :value="order.shipping.name"
                          disabled
                        >
                      </div>
                    </div>

                    <div class="w-2/3 p-2">
                      <label for="shipToAddress" class="block text-sm font-medium leading-5 text-gray-700">Ship To Address</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="shipToAddress"
                          :value="shippingAddress"
                          disabled
                        >
                      </div>
                    </div>

                    <div class="w-1/3 p-2">
                      <label for="shipToCode" class="block text-sm font-medium leading-5 text-gray-700">Ship To Code</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="shipToCode"
                          :value="order.shipping.id"
                          disabled
                        >
                      </div>
                    </div>

                    <div class="w-6/12 p-2">
                      <label for="bol" class="block text-sm font-medium leading-5 text-gray-700">Delivery Type</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <select
                            class="form-input block w-full sm:text-sm sm:leading-5 sk-select"
                            name="delivery_type"
                            :value="ao.delivery_type"
                            v-on:change="inputValueChanged"
                            :disabled=isDisabled
                        >
                          <option value="1">FedEx</option>
                          <option value="2">CH Robinson</option>
                          <option value="3">Old Dominion</option>
                        </select>
                      </div>
                    </div>

                    <div class="w-6/12 p-2">
                      <label for="delivery_tracking_code" class="block text-sm font-medium leading-5 text-gray-700">Delivery Tracking Code</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            type="text"
                            class="form-input block w-full sm:text-sm sm:leading-5"
                            name="delivery_tracking_code"
                            :value="ao.delivery_tracking_code"
                            v-on:change="inputValueChanged"
                            :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <div class="w-6/12 p-2">
                      <label for="delivery_status" class="block text-sm font-medium leading-5 text-gray-700">Delivery status</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                            type="text"
                            class="form-input block w-full sm:text-sm sm:leading-5"
                            name="delivery_status"
                            v-model="delivery_status"
                            required
                            disabled
                        >
                      </div>
                    </div>

                    <div class="w-6/12 p-2 pl-6 align-items-end">
                      <div class="relative">
                        <button type="submit" @click.prevent="syncBtnClick" :disabled="disableSyncBtn" class="sk-btn-fix rounded-full flex items-center text-base text-white shadow-solid bg-green py-3 px-4 mt-4">Sync delivery status</button>
                      </div>
                    </div>

                    <!-- TODO: This number is actually attached to the shipping address. We need to update the shipping address if this changes. -->
                    <div class="w-1/2 p-2">
                      <label for="hrmsCode" class="block text-sm font-medium leading-5 text-gray-700">HRMS Ship To #</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="hrmsCode"
                          :value="ao.hrmsCode"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="hrms_release_number" class="block text-sm font-medium leading-5 text-gray-700">HRMS Release #</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="hrms_release_number"
                          :value="ao.hrms_release_number"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <!-- TODO: Add this to allocated order model -->
                    <div class="w-1/2 p-2">
                      <label for="qtyPallets" class="block text-sm font-medium leading-5 text-gray-700">Qty. Pallets</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="number"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="qtyPallets"
                          :value="ao.qtyPallets"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <!-- TODO: Add this to allocated order model -->
                    <div class="w-1/2 p-2">
                      <label for="approximateWeightLoad" class="block text-sm font-medium leading-5 text-gray-700">Approximate Weight Load</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="number"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="approximateWeightLoad"
                          :value="ao.approximateWeightLoad"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="transitDays" class="block text-sm font-medium leading-5 text-gray-700">Transit Days</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="transitDays"
                          :value="order.shipping.transitDays"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="aniticipatedPU" class="block text-sm font-medium leading-5 text-gray-700">Anticipated Pick-up Date</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <date-picker
                          value-type="YYYY-MM-DD"
                          format="MM/DD/YYYY"
                          name="aniticipatedPU"
                          v-model="ao.aniticipatedPU"
                          :disabled="isDisabled"
                        />
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="actualPU" class="block text-sm font-medium leading-5 text-gray-700">Actual Pick-up Date</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <date-picker
                          value-type="YYYY-MM-DD"
                          format="MM/DD/YYYY"
                          name="actualPU"
                          v-model="ao.actualPU"
                          :disabled="isDisabled"
                        />
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="anticipatedDD" class="block text-sm font-medium leading-5 text-gray-700">Anticipated Delivery Date</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <date-picker
                          value-type="YYYY-MM-DD"
                          format="MM/DD/YYYY"
                          name="anticipatedDD"
                          v-model="ao.anticipatedDD"
                          :disabled="isDisabled"
                        />
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="actualDD" class="block text-sm font-medium leading-5 text-gray-700">Actual Delivery Date</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <date-picker
                          value-type="YYYY-MM-DD"
                          format="MM/DD/YYYY"
                          name="actualDD"
                          v-model="ao.actualDD"
                          :disabled="isDisabled"
                        />
                      </div>
                    </div>

                    <div class="w-1/2 p-2">
                      <label for="bol" class="block text-sm font-medium leading-5 text-gray-700">BOL Number</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="bol"
                          :value="order.shipping.bol"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <div class="w-1/2 p-2 hidden">
                      <label for="chr" class="block text-sm font-medium leading-5 text-gray-700">CHR Number</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="chr"
                          :value="order.shipping.chr"
                          v-on:change="inputValueChanged"
                          :disabled=isDisabled
                        >
                      </div>
                    </div>

                    <div class="w-full p-2">
                      <label for="notes" class="block text-sm font-medium leading-5 text-gray-700 mb-2">Notes</label>
                      <div class="max-w-lg flex rounded-md shadow-sm">
                        <editor
                          api-key="skv2keu22mkkh9x439gwsx3neyd7hd023ff8m5iofqifchs4"
                          :init="{
                            height: 300,
                            menubar: false,
                            plugins: [
                              'advlist autolink lists link image charmap print preview anchor',
                              'insertdatetime media table paste code help wordcount'
                            ],
                            toolbar:
                              'undo redo | formatselect | bold italic backcolor | \
                              alignleft aligncenter alignright alignjustify | \
                              bullist numlist outdent indent | removeformat | help'
                          }"
                          v-model="orderShippingNotes"
                          :disabled=isDisabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="delivery" class="shadow-sm p-4">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h2 class="header text-xl text-green">Delivery Information</h2>
                </div>
              </div>

              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6 flex flex-wrap">

                    <div class="w-1/3 p-2">
                      <label for="receivingContactName" class="block text-sm font-medium leading-5 text-gray-700">Receiving Contact Name</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="receivingContactName"
                          :value="ao.receivingContactName"
                          v-on:change="inputValueChanged"
                        >
                      </div>
                    </div>

                    <div class="w-1/3 p-2">
                      <label for="receivingContactEmail" class="block text-sm font-medium leading-5 text-gray-700">Receiving Contact Email</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="receivingContactEmail"
                          :value="ao.receivingContactEmail"
                          v-on:change="inputValueChanged"
                        >
                      </div>
                    </div>

                    <div class="w-1/3 p-2">
                      <label for="receivingContactPhone" class="block text-sm font-medium leading-5 text-gray-700">Receiving Contact Phone</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="receivingContactPhone"
                          :value="ao.receivingContactPhone"
                          v-on:change="inputValueChanged"
                        >
                      </div>
                    </div>

                    <div class="w-4/12 p-2">
                      <label for="webPortal" class="block text-sm font-medium leading-5 text-gray-700">Web Portal</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="webPortal"
                          :value="ao.webPortal"
                          v-on:change="inputValueChanged"
                        >
                      </div>
                    </div>

                    <div class="w-4/12 p-2">
                      <label for="deliveryWindow" class="block text-sm font-medium leading-5 text-gray-700">Delivery Window</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="deliveryWindow"
                          :value="ao.deliveryWindow"
                          v-on:change="inputValueChanged"
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="po" class="shadow-sm p-4">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h2 class="header text-xl text-green">Purchase Order</h2>
                </div>
              </div>

              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow sm:rounded-md">
                  <div class="px-4 py-5 bg-white sm:p-6 flex flex-wrap">
                    <div class="w-2/12 p-2">
                      <label for="poRequired" class="block text-sm font-medium leading-5 text-gray-700 mb-2">Is a PO Number Required?</label>
                      <input id="poRequired" name="poRequired" type="checkbox" :checked="ao.poRequired" v-on:click="checkboxValueChanged">
                    </div>

                    <div class="w-4/12 p-2">
                      <label for="poNum" class="block text-sm font-medium leading-5 text-gray-700">PO Number</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <input
                          type="text"
                          class="form-input block w-full sm:text-sm sm:leading-5"
                          name="poNum"
                          :value="ao.poNum"
                          v-on:change="inputValueChanged"
                        >
                      </div>
                    </div>

                    <div class="w-4/12 p-2">
                      <label for="poDate" class="block text-sm font-medium leading-5 text-gray-700">PO Date for Delivery</label>
                      <div class="mt-1 relative rounded-md shadow-sm">
                        <date-picker
                          value-type="YYYY-MM-DD"
                          format="MM/DD/YYYY"
                          v-model="ao.poDate"
                          name="poDate"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="order-instructions" class="shadow-sm p-4">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h2 class="header text-xl text-green">Special Instructions</h2>
                </div>
              </div>

              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="shadow sm:rounded-md sm:overflow-hidden">
                  <div class="px-4 py-5 bg-white sm:p-6 flex flex-wrap">
                    <div class="w-full p-2 flex rounded-md shadow-sm">
                      <editor
                        api-key="skv2keu22mkkh9x439gwsx3neyd7hd023ff8m5iofqifchs4"
                        :init="{
                          height: 300,
                          menubar: false,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'insertdatetime media table paste code help wordcount'
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | removeformat | help'
                        }"
                        v-model="ao.specialInstructions"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section id="items" class="shadow-sm p-4">
            <div class="md:grid md:grid-cols-3 md:gap-6">
              <div class="md:col-span-1">
                <div class="px-4 sm:px-0">
                  <h2 class="header text-xl text-green">Ordered Kits</h2>
                </div>
              </div>

              <div class="mt-5 md:mt-0 md:col-span-2">
                <table class="min-w-full divide-y divide-grey">
                  <thead>
                    <tr>
                      <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Quantity
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      class="bg-white"
                      v-for="(item, index) in order.items"
                      :key="index"
                    >
                      <td class="px-6 py-4 whitespace text-sm leading-5 font-medium text-gray-900" v-html="item.title"/>
                      <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500" v-html="item.qty"/>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          <section id="actions" class="rounded-md shadown-sm p-4 flex justify-end">
            <button type="submit" @click.prevent="submit" :disabled="submitting" class="rounded-full flex items-center text-base text-white shadow-solid bg-green py-2 px-4 mt-4">Save</button>
          </section>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import DatePicker from 'vue2-datepicker';

export default {
  name: 'VendorAllocatedOrder',
  components: {
    Editor,
    DatePicker
  },
  props: {
    order: Object,
  },
  data() {
    console.log(this.order.orderStatus);
    return {
      ao: {
        aniticipatedPU: this.order.shipping.aniticipatedPU,
        actualPU: this.order.shipping.pickupDate,
        anticipatedDD: this.order.shipping.anticipatedDD,
        actualDD: this.order.shipping.actualDD,
        poDate: this.order.po.poDate,
        bol: this.order.shipping.bol,
        chr: this.order.shipping.chr,
        notes: this.order.shipping.notes,
        delivery_type: this.order.delivery.delivery_type,
        delivery_tracking_code: this.order.delivery.delivery_tracking_code,
        approximateWeightLoad: this.order.shipping.approximateWeightLoad,
        qtyPallets: this.order.shipping.qtyPallets,
        hrms_release_number: this.order.shipping.hrms_release_number,
        transitDays: this.order.shipping.transitDays,
        hrmsCode: this.order.shipping.hrmsCode,
        receivingContactName: this.order.delivery.name,
        receivingContactEmail: this.order.delivery.email,
        receivingContactPhone: this.order.delivery.phone,
        webPortal: this.order.delivery.portal,
        deliveryWindow: this.order.delivery.window,
        poRequired: this.order.po.required,
        poNum: this.order.po.poNum,
        specialInstructions: this.order.allocationInstructions
      },
      orderStatus: this.order.orderStatus,
      allocationOrderStatus: this.order.allocationOrderStatus,
      statuses: [
        {
          value: 6,
          text: 'Allocated'
        },
        {
          value: 7,
          text: 'Vendor Review'
        },
        {
          value: 8,
          text: 'Estimated Shipping Provided'
        },
        {
          value: 9,
          text: 'PO Needed'
        },
        {
          value: 10,
          text: 'Shipped'
        },
        {
          value: 11,
          text: 'In Transit'
        },
        {
          value: 4,
          text: 'Delivered'
        }
      ],
      delivery_status: '',
      orderInstructions: this.order.instructions,
      orderShippingNotes: this.order.shipping.notes,
      submitting: false
    }
  },
  mounted(){
    this.delivery_status = this.order.delivery.delivery_status;
  },
  methods: {
    submit () {
      this.submitting = true;

      const data = {
        aniticipatedPU: this.ao.aniticipatedPU,
        actualPU: this.ao.actualPU,
        anticipatedDD: this.ao.anticipatedDD,
        actualDD: this.ao.actualDD,
        poDate: this.ao.poDate,
        bol: this.ao.bol,
        chr: this.ao.chr,
        notes: this.orderShippingNotes,
        instructions: this.orderInstructions,
        orderId: this.order.orderId,
        delivery_type: this.ao.delivery_type,
        delivery_tracking_code: this.ao.delivery_tracking_code,
        approximateWeightLoad: this.ao.approximateWeightLoad,
        qtyPallets: this.ao.qtyPallets,
        hrms_release_number: this.ao.hrms_release_number,
        orderStatus: this.orderStatus,
        allocationOrderStatus: this.allocationOrderStatus,
        shipToAddressId: this.order.shipping.id,
        transitDays: this.ao.transitDays,
        hrmsCode: this.ao.hrmsCode,
        receivingContactName: this.ao.receivingContactName,
        receivingContactEmail: this.ao.receivingContactEmail,
        receivingContactPhone: this.ao.receivingContactPhone,
        webPortal: this.ao.webPortal,
        deliveryWindow: this.ao.deliveryWindow,
        poRequired: this.ao.poRequired,
        poNum: this.ao.poNum,
        specialInstructions: this.ao.specialInstructions
      }

      console.log(data);

      if(!this.disableSyncBtn&&this.delivery_status!==''){
        data.delivery_status = this.delivery_status;
      }

      // Updating the Allocated Order
      axios.post(`/allocation/vendor/${this.order.aoId}`, data).then((res) => {
        document.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
    },
    inputValueChanged (e) {
      this.ao[e.target.name] = e.target.value;
      console.log(this.ao);
    },
    checkboxValueChanged (e) {
      var isChecked = document.getElementById(e.target.id).checked;
      this.ao[e.target.name] = isChecked;
      console.log(this.ao);
    },
    syncBtnClick(){
      axios.post(`/allocation/delivery-sync/${this.order.aoId}`,{
        delivery_type: this.ao.delivery_type,
        delivery_tracking_code: this.ao.delivery_tracking_code,
        qtyPallets: this.ao.qtyPallets,
        hrms_release_number: this.ao.hrms_release_number,        
        orderStatus: this.ao.orderStatus
      }).then(
          (res)=>{
            if(res.data.status===200){
              this.delivery_status = res.data.delivery_message;
              this.orderStatus = res.data.orderStatus;
              this.allocationOrderStatus = res.data.allocationOrderStatus;
            }else{
              alert('Tracking information not found');
            }
            console.log(res);
          }
      )
    }
  },
  computed: {
    isDisabled() {
      return this.order.limited;
    },
    regionalDirector () {
      let rd = this.order.rd;
      return `${rd.firstName} ${rd.lastName} - <a href="mailto:${rd.email}">${rd.email}</a>`;
    },
    shippingAddress () {
      let ship = this.order.shipping.address;
      return `${ship.streetAddress}, ${ship.city}, ${ship.state}, ${ship.zip}`;
    },
    disableSyncBtn(){
      return (Number(this.ao.delivery_type)!==1&&Number(this.ao.delivery_type)!==2&&Number(this.ao.delivery_type)!==3)||this.ao.delivery_tracking_code==='';
    }
  },
}
</script>
